import { useIonViewDidEnter, useIonViewDidLeave, IonRefresherContent, IonRefresher, IonGrid, IonCol, IonRow, IonSearchbar, useIonViewWillEnter, useIonRouter, IonBackButton, IonButton, IonButtons, IonCard, IonContent, IonHeader, IonInput, IonItem, IonLabel, IonPage, IonTitle, IonToolbar } from "@ionic/react";
import { people } from 'ionicons/icons';
import React, { useState, useRef, useEffect }  from 'react';
import { RouteComponentProps } from "react-router-dom";
import { Virtuoso } from 'react-virtuoso';

import { showAlert } from '../components/Alert';
import Vault, { FirstTime } from '../components/Vault';
import { Device } from '@capacitor/device';
import { Browser } from '@capacitor/browser';
import NServer, { UIElement, handleRouteError } from "../components/NServer";
import { ContentInfo, CreateContentInfo, FilterUniqueContent, ReponsiveContentResize, ReponsiveContentItemResize } from "../data/item";
import ContentWrapper from "../components/ContentWrapper";
import { LANGUAGE, GetStr } from "../language/Language";
import NoMoreContent from "../components/NoMoreContent";

import '../pages/Main.css'; 

var index = 0;
const total = 4;
var tokens = 0;
var noMoreLoadData = false;
var userName = '';
var userAvatar = "/assets/img/avt.jpg";
var ownUser = false;
var relationship = -1;
var followers = 0;
var loading = false;
var bm = 0;
var curUser = "";

interface UserProp extends RouteComponentProps<{
    id : string
    }> 
{} 

const User : React.FC<UserProp> = ({match}) => {

    const [searchText, setSearchText] = useState('');
    const [contents, setContents] = useState<ContentInfo[]>([]);
    const [streams, setStreams] = useState<ContentInfo[]>([]);
    const [endOfContent, setEndOfContent] = useState(false);
    const [canRefresh, setCanRefresh] = useState(true);

    //	Initializing our router
	const router = useIonRouter();

    useIonViewDidEnter(() => {        
    });

    useEffect(() => {
        // user changed refresh page
        if (index == 0 || match.params.id != curUser)
            doRefresh(null);

        // load again in case first time is not loaded
        setTimeout( () => {
            let e = document.getElementById("nc-content");
            if ((e == null || match.params.id != curUser) && !loading)
                doRefresh(null);
        }, 1000);     
    }, [match.params.id]);

    // when search text is changed
    useEffect(() => {
        // filter here
        let query = searchText.toLowerCase();
        if (query == "")
        {
            noMoreLoadData = false;
            setContents(getDefContents().concat(streams));
        }
        else
        {
            noMoreLoadData = true;

            setContents(streams.filter(d => 
                (d.desc.toLowerCase().indexOf(query) > -1) ||
                (d.title.toLowerCase().indexOf(query) > -1)));
        }
    }, [searchText]);

    // check whether own user or not
    const checkOwnUserOrNot = async () => {
        ownUser = false;

        let v = new Vault();
        await v.read();
        
        // check whether own user or other user
        if (match.params.id == ("" + v.account.id))
            ownUser = true;
        if (match.params.id == "me")
            ownUser = true;
    }

    const loadMoreData = async () => {
        if (noMoreLoadData || loading)
            return;

        await getData();
    }

    const getData = async () => {
        let v = new Vault();
        await v.read();

        let user_id = match.params.id;
        if (match.params.id == "me")
            user_id = "" + v.account.id;

        const state = {
            id: v.account.id,
            pass: v.account.key,
            s: index,
            e: total,
            user: user_id
        }

        loading = true;

        // check whether own user or other user
        ownUser = false;
        if (match.params.id == ("" + v.account.id))
            ownUser = true;
        if (match.params.id == "me")
            ownUser = true;

        var server = new NServer();
        await server.getList("nc_user_stream", state);
        if (!server.success && server.message != "")
        {
            showAlert(server.message);
            // handle route error if there is any
            handleRouteError(router, server.data);
        }
        else
        {
            const d = server.data;

            if (d != null)
            {
                userName = d.name;
                userAvatar = d.avatar;
                relationship = d.relationship;
                followers = d.followers;
                bm = d.bm;

                var dataStream = null;
                if (server.data.stream != null)
                {
                    if (index == 0)
                        dataStream = server.data.stream;
                    else
                        dataStream = streams.concat(server.data.stream);
                    
                    // filter
                    dataStream = FilterUniqueContent(dataStream);
                    // responsive resize
                    dataStream = ReponsiveContentResize("user-con-view", dataStream);

                    setStreams(dataStream);
                }
                
                // if we reach end of data
                noMoreLoadData = d.nomore == "yes";
                index = d.index;

                let contentStream = getDefContents().concat(dataStream);
                
                setContents(contentStream);

                setEndOfContent(noMoreLoadData);
            }
        }

        loading = false;
    }

    // get the default content type array
    const getDefContents = () : ContentInfo[] => {
        
        let userPanel = CreateContentInfo(0, "user", userName, userAvatar);
        userPanel.user = parseInt(match.params.id);
        userPanel.relationship = relationship;
        userPanel.likes = followers;
        userPanel.user_bm = bm;

        let threads : ContentInfo[] = [
            userPanel
        ];

        if (ownUser)
        {
            let mePanel = CreateContentInfo(0, "me", userName, userAvatar);
            mePanel.likes = followers;
            mePanel.user_bm = bm;

            threads = [
                mePanel,
                CreateContentInfo(1, "addmy", "", userAvatar)
            ];
        }

        return threads;
    }

    // just update specific content
    const getContentData = async (index: number, id : number) => {
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            content: id
        }

        var server = new NServer();
        await server.getList("nc_content", state);
        if (server.success)
        {
            if (server.data.tokens != null)
                tokens = server.data.tokens;

            let contentData : ContentInfo = server.data.content;
            contentData = ReponsiveContentItemResize("user-con-view", contentData);

            let defStream = getDefContents();
            streams[index-defStream.length] = contentData;
            
            // need to copy stream to update
            let streamCopy = streams.slice();
            setStreams(streamCopy);
            setContents(defStream.concat(streamCopy));
        }
    }

    // update a content
    const onUpdateContent = (index : number, content : ContentInfo, local : boolean) => {
        if (local)
        {
            // local update
            let defStream = getDefContents();
            streams[index-defStream.length] = content;
            
            // need to copy stream to update
            let streamCopy = streams.slice();
            setStreams(streamCopy);
            setContents(defStream.concat(streamCopy));
        }
        else
            getContentData(index, content.id);
    }

    const doSearch = async (term : string) => {
        setSearchText(term);
    }

    // refresh event
    const doRefresh = async (ev : any) => {
        // reset data first
        userName = '';
        userAvatar = "/assets/img/avt.jpg";
        noMoreLoadData = false;
        index = 0;
        bm = 0;
        followers = 0;
        ownUser = false;
        loading = false;
        setStreams([]);

        // copy current user
        curUser = match.params.id;

        await checkOwnUserOrNot();

        await getData();

        if (ev != null)
            ev.detail.complete();
    };

    // scroll event
    const onScrollTop = (val : boolean) => {
        setCanRefresh(val);
    }

    return (
        <IonPage>
            <IonToolbar color="none">
                <IonButtons slot="start">
                    <IonBackButton text="" defaultHref="/main" color="dark"></IonBackButton>
                </IonButtons>
                <IonSearchbar className="search-bubble" placeholder={ GetStr(LANGUAGE.TXT_SEARCH) } value={searchText} onIonChange={e => doSearch(e.detail.value!)}></IonSearchbar>
            </IonToolbar>
            <IonContent fullscreen scrollY={false}>
                <IonRefresher className="refresher" slot="fixed" disabled={!canRefresh} onIonRefresh={doRefresh}>
                    <IonRefresherContent></IonRefresherContent>
                </IonRefresher>
                <IonGrid className="ion-no-padding full-screen">
                    <IonRow className="full-screen">
                        <IonCol>
                        </IonCol>
                        <IonCol size-md="8" size-lg="6" size-xl="5" size-sm="10" size="12">
                            <Virtuoso id="user-con-view" className="main-content ion-content-scroll-host"
                                defaultItemHeight={350}
                                data={contents}
                                totalCount={contents.length}
                                endReached={loadMoreData}
                                atTopStateChange={onScrollTop}
                                components={{
                                    Footer: () => {
                                        return (
                                            <NoMoreContent nomore={endOfContent} />
                                        )
                                    },
                                }}
                                itemContent={(index, content) => 
                                    <ContentWrapper key={content.id} content={content} index={index} onUpdate={onUpdateContent} view="def" autoplay={false} />
                                }
                            >
                            </Virtuoso>
                        </IonCol>
                        <IonCol>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonContent>
        </IonPage>
    );
};

export default User;